module.exports = __webpack_public_path__ + "static/media/map_gladsaxe2.dac22ba6.jpg";